/**
 * @bos/portal3 — THE VERDICT ROOM (`/app/runs/:id/verdict`).
 *
 * The end of the run: what was built, what was checked, what failed, and — the part the
 * product is proudest of — what the machine could not prove. It was called "Checks" on the
 * old rail while every other sentence in the portal (the download card, the archive
 * explainer) sent people looking for "The verdict". It now has that name, and an address
 * to match.
 */
import { useRunVerdict } from '../hooks';
import { VerdictReview } from '../VerdictReview';
import { useRunRoom } from '../roomContext';

export function VerdictRoom() {
  const { runId, ready, statusKey, rail, terminal } = useRunRoom();
  const { verdict, vStatus, vError } = useRunVerdict(runId, ready, statusKey);

  return (
    <VerdictReview
      payload={verdict}
      status={vStatus === 'idle' ? 'loading' : vStatus}
      error={vError}
      railState={rail.find((r) => r.key === 'checks')?.state ?? null}
      terminal={terminal}
    />
  );
}
